import { css } from '@genesislcap/web-core';

export const WatchlistBondsManagerStyles = css`
  :host {
    /* Add custom styles here if needed */
  }
`; 